const Security = class {
    constructor() {
        this._gateway = false;
    }

    restrictToGateway() {
        this._gateway = true;
    }

    isRestrictedToGateway() {
        return this._gateway;
    }

    init(xsrf, auth, audit) {
        this.setCSRFToken(xsrf);
        this.setAuthToken(auth);
        this.setAuditUser(audit);
    }

    initFromDOM() {
        this.init(
            document.getElementById("xsrf").content,
            document.getElementById("authToken")?.content,
            document.getElementById("auditUser")?.content
        );
    }

    getCSRFToken() {
        return this.xsrfToken;
    }

    setCSRFToken(token) {
        this.xsrfToken = token;
    }

    getAuthToken() {
        return this.subAuthToken;
    }

    setAuthToken(token) {
        delete this.subAuthToken;
        if(token && token.length > 0) {
            this.subAuthToken = token;
        }
    }

    getAuditUser() {
        return this.subAuditUser;
    }

    setAuditUser(user) {
        delete this.subAuditUser;
        if(user && user.length > 0) {
            this.subAuditUser = user;
        }
    }
};

export default new Security();
